export const DATASET_OPTIONS = {
  methods: ['deseq2', 'wrst'],
  directions: ['up', 'down'],
  scopes: ['all', 'subset'],
};

const DEFAULT_SELECTION = {
  method: 'deseq2',
  direction: 'up',
  scope: 'all',
};

function supported(value, values, fallback) {
  return values.includes(value) ? value : fallback;
}

export function parseDatasetSelection(searchParams) {
  return {
    method: supported(
      searchParams.get('method'),
      DATASET_OPTIONS.methods,
      DEFAULT_SELECTION.method,
    ),
    direction: supported(
      searchParams.get('direction'),
      DATASET_OPTIONS.directions,
      DEFAULT_SELECTION.direction,
    ),
    scope: supported(
      searchParams.get('scope'),
      DATASET_OPTIONS.scopes,
      DEFAULT_SELECTION.scope,
    ),
  };
}

export function getDatasetKey({ method, direction, scope }) {
  const backendMethod = method === 'wrst' ? 'wilcox' : 'deseq2';
  const backendScope = scope === 'subset' ? 'select' : 'all';
  const directionSuffix = direction === 'down' ? '_d' : '';
  return `${backendMethod}_${backendScope}${directionSuffix}`;
}
